import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Switch.module.scss';

const Switch = ({ label = '', className = '', onSwitch, checked, disabled }) => {
  const handleChange = () => {
    if (!disabled) onSwitch(!checked);
  };

  return (
    <div className={cn(styles.container, className)}>
      {label ? <span>{label}</span> : null}
      <label className={styles.switch} htmlFor="name" onClick={handleChange}>
        <input disabled={disabled} type="checkbox" checked={checked} onChange={handleChange} />
        <span className={cn(styles.slider, styles.round)} />
      </label>
    </div>
  );
};

export default Switch;

Switch.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onSwitch: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
